import React, { Component, useContext } from "react";
import { Auth } from "aws-amplify";
import { withRouter } from "react-router-dom";

const defaultAuthContext = {
  isAuthenticated: false,
  setIsAuthenticated: () => {},
  signOut: () => {},
  siteHasAuthentication: false
};

export const AuthContext = React.createContext(defaultAuthContext);

class AuthSiteWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      setIsAuthenticated: authed => this.setState({ isAuthenticated: authed }),
      siteHasAuthentication:
        this.props.site.enabledUserAccounts ||
        defaultAuthContext.siteHasAuthentication,
      signOut: this.signOut
    };
  }

  async componentDidMount() {
    try {
      // calling will refresh session if access token is expired
      await Auth.currentSession();
      this.setState({ isAuthenticated: true });
    } catch (err) {
      // No user session, leave user as unauthenticated
      if (err === "No current user") return;

      // Session exists, but the session's refresh token is expired
      // user needs to sign in again to renew their refresh token
      if (err === "NotAuthorizedException") {
        return this.props.history.push("/auth");
      }

      // unexpected error, shouldn't get to this step
      console.error("Unexpected error in AuthSiteWrapper", err);
    }
  }

  signOut = () => {
    Auth.signOut();
    this.setState({ isAuthenticated: false });
  };

  render() {
    return (
      <AuthContext.Provider value={this.state}>
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

export const AuthProvider = withRouter(AuthSiteWrapper);
export const AuthConsumer = AuthContext.Consumer;
export const useAuthContext = () => useContext(AuthContext);
